import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import {getRestParamErrorMessage, getRestResponseErrorMessage} from '@/utils/serverErrorMessageUtil';

export default Vue.component('email-setting-card', {
  name: 'emailSettingCard',
  props: {
    apiPath: {type: String, required: true},
    fieldName: {type: String, required: true},
    description: {type: String, required: true}
  },
  data () {
    return {
      cardExpanded: false,
      notificationEmailErrorMessage: '',
      loadingInitialData: false,
      updatingEmail: false,
      notificationEmail: '',
      initialNotificationEmail: ''
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner
  },
  created: function () {
  },
  methods: {
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.getExpiringCertificationsNotificationEmail()
      }
    },
    async getExpiringCertificationsNotificationEmail () {
      try {
        this.loadingInitialData = true;
        const response = await HTTP.get(this.apiPath);
        this.loadingInitialData = false;
        if (!response.data || !response.data.data || !response.data.data[this.fieldName]) {
          throw new Error("Error retrieving email.");
        }
        this.notificationEmail = response.data.data[this.fieldName];
        this.initialNotificationEmail = this.notificationEmail;
      } catch(err) {
        console.log('response Error!');
        this.loadingInitialData = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: `Error Retrieving ${this.description}`,
          text: `An error occurred retrieving the ${this.description}.`
        });
      }
    },
    cancel () {
      this.notificationEmail = this.initialNotificationEmail;
    },
    getNewFieldName(): string {
      return "new" + this.fieldName.charAt(0).toUpperCase() + this.fieldName.slice(1);
    },
    async updateEmail (notificationEmail: string) {
      this.notificationEmailErrorMessage = '';

      try {
        this.updatingEmail = true;
        const fieldName = this.getNewFieldName();
        const data: any = {};
        data[fieldName] = notificationEmail;
        const response = await HTTP.put(this.apiPath, data);
        this.updatingEmail = false;
        if (response.data.success) {
          this.initialNotificationEmail = this.notificationEmail;
          this.$notify({
            group: 'main',
            type: 'success',
            title: 'Success',
            text: `Successfully updated the ${this.description} Address.`
          });
        } else {
          this.$notify({
            group: 'main',
            type: 'error',
            title: `Error Editing ${this.description} Address`,
            text: `An error occurred updating ${this.description} address.`
          });
        }
      } catch (error) {
        this.updatingEmail = false;

        this.notificationEmailErrorMessage = getRestParamErrorMessage(error, this.getNewFieldName());
        if (!this.notificationEmailErrorMessage.length) {
          let generalError = getRestResponseErrorMessage(error);
          this.$notify({
            group: 'main',
            type: 'error',
            title: `Error Editing ${this.description} Address`,
            text: generalError ? generalError : 'An error occurred updating the email address.',
            // duration: 5000
          });
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/componentsReusable/cards/emailSetting/EmailSettingCard.ts